import * as ACTION_TYPES from "./actionTypes";
import { EMPTY_PLAN_OBJECT } from "../constants/objectTemplates";
import { unSecure, secure } from "./API/faiz";
import { DURATIONS, DAYS, FAIZ_ACCESS_TOKEN } from "../constants/staticKeys";
import { errorMessageHandle } from "../constants/utilities";
import { toast } from "react-toastify";

const {
  UPDATE_SHEDULE_BUILDER_PROPS,
  DELETE_SHEDULE_BUILDER_PROPS,
  MERGE_SHEDULE_BUILDER_PROPS,
} = ACTION_TYPES;
export const updateScheduleBuilderProp = (prop, value) => {
  return { type: UPDATE_SHEDULE_BUILDER_PROPS, payload: [{ prop, value }] };
};
export const updateScheduleBuilderProps = (payload) => {
  return { type: UPDATE_SHEDULE_BUILDER_PROPS, payload: payload };
};
export const mergeScheduleBuilderProps = (payload) => {
  return { type: MERGE_SHEDULE_BUILDER_PROPS, payload: payload };
};
export const deleteScheduleBuilderProp = (prop) => {
  return { type: DELETE_SHEDULE_BUILDER_PROPS, payload: [{ prop }] };
};
export const deleteScheduleBuilderProps = (payload) => {
  return { type: DELETE_SHEDULE_BUILDER_PROPS, payload };
};

export const createNewPlan = (name, plans) => (dispatch, getState) => {
  if (plans.length < 10) {
    let plan = JSON.parse(JSON.stringify(EMPTY_PLAN_OBJECT));
    plan.name = name;
    dispatch({
      type: MERGE_SHEDULE_BUILDER_PROPS,
      payload: [{ prop: "plans", value: [plan] }],
    });
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [
        { prop: "isOpenNewPlanModal", value: false },
        { prop: "newPlanName", value: "" },
        { prop: "isEfficiencyDirty", value: true },
      ],
    });
  } else {
    toast.error("Plan limit reached (Max 10). ");
  }
};

export const deletePlan = (plan, planIndex) => async (dispatch, getState) => {
  if (plan.hasOwnProperty("id")) {
    let url = "masterplan";
    let param = { plans: [plan.id] };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [
        { prop: "plans." + planIndex + ".isDeleteLoading", value: true },
      ],
    });
    secure(token)
      .delete(url, { data: param })
      .then((response) => {
        dispatch({
          type: DELETE_SHEDULE_BUILDER_PROPS,
          payload: [{ prop: "plans." + planIndex }],
        });
        dispatch({
          type: UPDATE_SHEDULE_BUILDER_PROPS,
          payload: [{ prop: "isEfficiencyDirty", value: true }],
        });
        let plans = getState().scheduleBuilderReducer.plans;
        if (plans.length > 0) {
          dispatch(computeSuggestions(plans));
        }
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_SHEDULE_BUILDER_PROPS,
          payload: [
            { prop: "plans." + planIndex + ".isDeleteLoading", value: false },
          ],
        });
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      });
  } else {
    dispatch({
      type: DELETE_SHEDULE_BUILDER_PROPS,
      payload: [{ prop: "plans." + planIndex }],
    });
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [{ prop: "isEfficiencyDirty", value: true }],
    });
  }
};

export const addVisitToDay =
  (planIndex, day, visit) => async (dispatch, getState) => {
    await dispatch({
      type: MERGE_SHEDULE_BUILDER_PROPS,
      payload: [
        { prop: "plans." + planIndex + "." + day + ".visits", value: visit },
      ],
    });
    let newVisits =
      getState().scheduleBuilderReducer.plans[planIndex][day].visits;
    let totalScore = calculateScore(newVisits);
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [
        {
          prop: "plans." + planIndex + "." + day + ".score",
          value: totalScore,
        },
        { prop: "isEfficiencyDirty", value: true },
      ],
    });
  };

export const removeVisitFromDay =
  (planIndex, day, visitIndex) => async (dispatch, getState) => {
    let prop = "plans." + planIndex + "." + day + ".visits." + visitIndex;
    await dispatch({ type: DELETE_SHEDULE_BUILDER_PROPS, payload: [{ prop }] });
    let newVisits =
      getState().scheduleBuilderReducer.plans[planIndex][day].visits;
    let totalScore = calculateScore(newVisits);
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [
        {
          prop: "plans." + planIndex + "." + day + ".score",
          value: totalScore,
        },
        { prop: "isEfficiencyDirty", value: true },
      ],
    });
  };

const calculateScore = (visits) => {
  let totalScore = 0;
  for (let i = 0; i < visits.length; i++) {
    totalScore = totalScore + parseFloat(visits[i].score);
  }
  return totalScore;
};

export const computeOptimalSuggestions =
  (plans, duration, weekDayIndex) => (dispatch, getState) => {
    let url = "/efficiencymatrix/compute";
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [
        {
          prop:
            "suggestedCombinations." +
            DURATIONS[duration - 1] +
            "." +
            DAYS[weekDayIndex] +
            ".isComputing",
          value: true,
        },
        {
          prop:
            "suggestedCombinations." +
            DURATIONS[duration - 1] +
            "." +
            DAYS[weekDayIndex] +
            ".result",
          value: null,
        },
      ],
    });
    unSecure()
      .post(url, { plans, duration, weekDayIndex })
      .then((res) => {
        dispatch({
          type: UPDATE_SHEDULE_BUILDER_PROPS,
          payload: [
            {
              prop:
                "suggestedCombinations." +
                DURATIONS[duration - 1] +
                "." +
                DAYS[weekDayIndex] +
                ".bestOption",
              value: res.data.computed,
            },
            {
              prop:
                "suggestedCombinations." +
                DURATIONS[duration - 1] +
                "." +
                DAYS[weekDayIndex] +
                ".result",
              value: true,
            },
          ],
        });
        if (duration === 7 && weekDayIndex === 6) {
          dispatch({
            type: UPDATE_SHEDULE_BUILDER_PROPS,
            payload: [{ prop: "isEfficiencyDirty", value: false }],
          });
        }
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_SHEDULE_BUILDER_PROPS,
          payload: [
            {
              prop:
                "suggestedCombinations." +
                DURATIONS[duration - 1] +
                "." +
                DAYS[weekDayIndex] +
                ".isComputing",
              value: false,
            },
          ],
        });
      });
  };

export const computeSuggestions = (plans) => async (dispatch, getState) => {
  // Get number of plans to use in permutaions generation.
  // let numberOfPlans = plans.length;
  // let planOptions = [];
  // for (let i = 0; i < numberOfPlans; i++) {
  //   planOptions.push(i);
  // }

  // Save the plans first
  // let url = "/masterplan";
  // let param = { plans: plans };
  // let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  // dispatch({ type: UPDATE_SHEDULE_BUILDER_PROPS, payload: [{ prop: "isMasterPlanSaveLoading", value: true }] });

  let distinctNames = Array.from(new Set(plans.map((s) => s.name))).map(
    (name) => {
      return {
        name: plans.find((s) => s.name === name).name,
      };
    }
  );
  if (plans.length === distinctNames.length) {
    for (let stay = 1; stay <= 7; stay++) {
      for (let weekDayIndex = 0; weekDayIndex < 7; weekDayIndex++) {
        dispatch(computeOptimalSuggestions(plans, stay, weekDayIndex));
      }
    }
  } else {
    toast.error("Plan names should be unique.");
  }
  // secure(token)
  //   .post(url, param)
  //   .then(response => {
  //     dispatch({ type: UPDATE_SHEDULE_BUILDER_PROPS, payload: [{ prop: "plans", value: response.data.masterPlan }] });
  //     if (
  //       response.data.masterPlan.filter(p => {
  //         return p.hasOwnProperty("code");
  //       }).length > 0
  //     ) {
  //       toast.error("Error saving plans. Review plans again then save");
  //     } else {
  //       toast.success(response.data.msg);
  //       // First loop is for possible duration of stay. Starts from 1 day to 7 days. any value greater than 7 is no neccesary to compute
  //       for (let stay = 1; stay <= 7; stay++) {
  //         for (let weekDayIndex = 0; weekDayIndex < 7; weekDayIndex++) {
  //           dispatch(computeOptimalSuggestions(response.data.masterPlan, stay, weekDayIndex));
  //         }
  //       }
  //     }
  //   })
  //   .catch(error => {
  //     let message;
  //     message = errorMessageHandle(error);
  //     toast.error(message);
  //   })
  //   .finally(f => {
  //     dispatch({ type: UPDATE_SHEDULE_BUILDER_PROPS, payload: [{ prop: "isMasterPlanSaveLoading", value: false }] });
  //   });
};

export const saveMasterPlans = (plans) => async (dispatch, getState) => {
  let url = "/masterplan";
  let param = { plans: plans };
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_SHEDULE_BUILDER_PROPS,
    payload: [{ prop: "isMasterPlanSaveLoading", value: true }],
  });
  secure(token)
    .post(url, param)
    .then((response) => {
      dispatch({
        type: UPDATE_SHEDULE_BUILDER_PROPS,
        payload: [{ prop: "plans", value: response.data.masterPlan }],
      });
      if (
        response.data.masterPlan.filter((p) => {
          return p.hasOwnProperty("code");
        }).length > 0
      ) {
        toast.error("Error saving plans. Review plans again then save");
      } else {
        toast.success(response.data.msg);
      }
    })
    .catch((error) => {
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_SHEDULE_BUILDER_PROPS,
        payload: [{ prop: "isMasterPlanSaveLoading", value: false }],
      });
    });
};

export const getMasterPlans = () => async (dispatch, getState) => {
  let url = "/masterplan";
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_SHEDULE_BUILDER_PROPS,
    payload: [{ prop: "isMasterPlanLoading", value: true }],
  });
  secure(token)
    .get(url)
    .then((response) => {
      dispatch({
        type: UPDATE_SHEDULE_BUILDER_PROPS,
        payload: [{ prop: "plans", value: response.data.plans.data }],
      });
    })
    .catch((error) => {
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_SHEDULE_BUILDER_PROPS,
        payload: [{ prop: "isMasterPlanLoading", value: false }],
      });
    });
};

export const getEfficiencyMatrix = () => async (dispatch, getState) => {
  let url = "/efficiencymatrix";
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_SHEDULE_BUILDER_PROPS,
    payload: [{ prop: "isEfficiencyMatrixLoading", value: true }],
  });
  secure(token)
    .get(url)
    .then((response) => {
      for (let i = 0; i < response.data.efficiencyMatrix.data.length; i++) {
        let d = response.data.efficiencyMatrix.data[i];
        let duration = d.duration;
        for (let z = 0; z < DAYS.length; z++) {
          dispatch({
            type: UPDATE_SHEDULE_BUILDER_PROPS,
            payload: [
              {
                prop:
                  "suggestedCombinations." +
                  DURATIONS[duration - 1] +
                  "." +
                  DAYS[z] +
                  ".isLoading",
                value: false,
              },
              {
                prop:
                  "suggestedCombinations." +
                  DURATIONS[duration - 1] +
                  "." +
                  DAYS[z] +
                  ".bestOption",
                value: d[DAYS[z]],
              },
              {
                prop:
                  "suggestedCombinations." +
                  DURATIONS[duration - 1] +
                  "." +
                  DAYS[z] +
                  ".result",
                value: true,
              },
            ],
          });
        }
      }
      // dispatch({
      //   type: UPDATE_SHEDULE_BUILDER_PROPS,
      //   payload: [{ prop: "suggestedCombinations", value: response.data.efficiencyMatrix.data }]
      // });
    })
    .catch((error) => {
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_SHEDULE_BUILDER_PROPS,
        payload: [{ prop: "isEfficiencyMatrixLoading", value: false }],
      });
    });
};

export const saveEfficiencyMatrix =
  (suggestedCombinations) => async (dispatch, getState) => {
    dispatch(saveMasterPlans(getState().scheduleBuilderReducer.plans));
    let url = "/efficiencymatrix";
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    let param = {};
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [{ prop: "isMatrixSaving", value: true }],
    });
    for (let i = 0; i < DURATIONS.length; i++) {
      for (let z = 0; z < DAYS.length; z++) {
        param = {
          computed: suggestedCombinations[DURATIONS[i]][DAYS[z]].bestOption,
          duration: i + 1,
          weekDayIndex: z,
        };
        dispatch({
          type: UPDATE_SHEDULE_BUILDER_PROPS,
          payload: [
            {
              prop:
                "suggestedCombinations." +
                DURATIONS[i] +
                "." +
                DAYS[z] +
                ".isSaving",
              value: true,
            },
            {
              prop:
                "suggestedCombinations." +
                DURATIONS[i] +
                "." +
                DAYS[z] +
                ".saved",
              value: false,
            },
          ],
        });
        secure(token)
          .post(url, param)
          .then((response) => {
            dispatch({
              type: UPDATE_SHEDULE_BUILDER_PROPS,
              payload: [
                {
                  prop:
                    "suggestedCombinations." +
                    DURATIONS[i] +
                    "." +
                    DAYS[z] +
                    ".saved",
                  value: true,
                },
              ],
            });
          })
          .catch((error) => {
            let message;
            message = errorMessageHandle(error);
            toast.error(message);
            dispatch({
              type: UPDATE_SHEDULE_BUILDER_PROPS,
              payload: [
                {
                  prop:
                    "suggestedCombinations." +
                    DURATIONS[i] +
                    "." +
                    DAYS[z] +
                    ".saved",
                  value: false,
                },
              ],
            });
          })
          .finally((f) => {
            dispatch({
              type: UPDATE_SHEDULE_BUILDER_PROPS,
              payload: [
                {
                  prop:
                    "suggestedCombinations." +
                    DURATIONS[i] +
                    "." +
                    DAYS[z] +
                    ".isSaving",
                  value: false,
                },
              ],
            });
          });
      }
    }
    dispatch({
      type: UPDATE_SHEDULE_BUILDER_PROPS,
      payload: [{ prop: "isMatrixSaving", value: false }],
    });
  };

export const saveScheduleBuilder =
  (plans, suggestedCombinations, isEfficiencyDirty) => (dispatch, getState) => {
    if (plans.length === 0) {
      toast.error("There are no plans created.");
      dispatch({ type: "" });
    } else if (isEfficiencyDirty) {
      toast.error("Effiecincy records are dirty. Re compute efficiency");
      dispatch({ type: "" });
    } else {
      // dispatch(saveMasterPlans(plans, suggestedCombinations));
      dispatch(saveEfficiencyMatrix(suggestedCombinations));
    }
  };
